import React, { Suspense, useEffect } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import SpinnerConstructor from "../structures/SpinnerConstructor";
import LoadingPage from "../components/LoadingPage";
import { Store } from "../store";
import { AuthSession } from "../store/ducks/auth";
import { AuthPersist } from "../store/ducks/authPersist";
import Logout from "../pages/auth/Logout";

const Home = React.lazy(() => import("./../pages/home/Home"));
const Login = React.lazy(() => import("./../pages/auth/Login"));
const DadosAcervo = React.lazy(() => import("./../pages/home/DadosAcervo"));
const ErrorPage = React.lazy(() => import("./../components/ErrorPage"));
const PearsonAuthPage = React.lazy(() => import("./../pages/auth/PearsonAuthPage"));
const DadosAutoridade = React.lazy(() => import("./../pages/home/DadosAutoridade"));
const Cesta = React.lazy(() => import("./../pages/home/Cesta"));

const Routers = () => (
  <Suspense fallback={<LoadingPage />}>
    <BrowserRouter basename={process.env.REACT_APP_PREFIX}>
      <Switch>
        <Route path={"/"} exact component={Home} />
        <Route path="/login" render={props => <Login {...props} />} />
        <Route path="/sair" render={props => <Logout {...props} />} />

        <Route path="/pearson" exact render={props => <PearsonAuthPage {...props} />} />
        {/* Cesta */}
        <Route path="/cesta" exact render={props => <Cesta {...props} />} />
        {/* Alterar rotas conforme navega no menu:  */}
        <Route path="/:guia" exact render={props => <Home {...props} />} />
        {/* Dados do acervo: */}
        <Route path="/acervo/:codAcervo" exact render={props => <DadosAcervo extras={false} {...props} />} />
        <Route path="/acervo/:codAcervo/referencia" exact render={props => <DadosAcervo extras={false} linkCurrent={"33"} {...props} />} />
        <Route path="/acervo/:codAcervo/marc" exact render={props => <DadosAcervo extras={false} linkCurrent={"36"} {...props} />} />
        <Route path="/acervo/:codAcervo/exemplares" exact render={props => <DadosAcervo extras={false} linkCurrent={"30"} {...props} />} />
        <Route path="/acervo/:codAcervo/dublin-core" exact render={props => <DadosAcervo extras={false} linkCurrent={"115"} {...props} />} />
        <Route path="/acervo/:codAcervo/reserva" exact render={props => <DadosAcervo extras={false} linkCurrent={"18"} {...props} />} />
        <Route path="/acervo/:codAcervo/solicitacao-emprestimo" exact render={props => <DadosAcervo extras={false} linkCurrent={"75"} {...props} />} />
        {/* Dados da Autoridade */}
        <Route path="/autoridade/:codAutoridade" exact render={props => <DadosAutoridade linkCurrent={"def"} {...props} />} />
        <Route path="/autoridade/:codAutoridade/marc" exact render={props => <DadosAutoridade linkCurrent={"marc"} {...props} />} />
        {/* Rota para fazer a autenticação para ebooks da pearson */}
        <Route path="*" render={props => <ErrorPage {...props} />} />
      </Switch>
    </BrowserRouter>
  </Suspense>
);

export default Routers;
